import React from 'react';

interface Props {
  zIndex?: number;
  onClick?: () => void;
}

const Overlay: React.FC<Props> = ({ zIndex = 100, onClick }) => {
  return (
    <div
      data-testid="overlay"
      className="fixed left-0 top-0 h-screen w-screen bg-black/10 backdrop-blur-[2px]"
      style={{ zIndex }}
      onClick={onClick}
    />
  );
};

export default Overlay;
